/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2019 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H133162 on 8/16/2019.
 *
 */

import {sliceItemsFromEnd} from "../../utils/Helpers";
import ExpandableList from "../../common/ExpandableList";
import React from "react";
import {FormattedHTMLMessage, FormattedMessage, injectIntl} from "react-intl";
import {formatDateTime} from "../../common/LocaleHelper";

class EventLogTable extends React.Component {
    getLogRow(log) {
        const changeText = <FormattedHTMLMessage
            id={'asset.log.' + log.objectType + '.' + log.actionType}
            values={{name: log.objectType === 'ASSET' ? log.assetName : log.objectName, state: log.valueId}}/>

        return (
            <div className="history-item" key={log.id}>
                <div className="history-item-header">
                    <FormattedMessage id="useranddate" values={{user: log.userName, date: formatDateTime(log.createDate)}} />
                </div>
                <div className="history-item-content">
                    {changeText}
                </div>
            </div>
        )
    }

    render() {
        const {eventLog, intl} = this.props

        const logComponents = eventLog.map(l => this.getLogRow(l))
        let emptyMessage = '';
        if (logComponents.length === 0) {
            emptyMessage = intl.formatMessage({id: "action.log.noAction"})
        }
        const slicedLogItems = sliceItemsFromEnd(logComponents, this.props.initDisplayCount);

        return (
            <div className="ui history-table">
                <ExpandableList content={slicedLogItems[0]} expandedContent={slicedLogItems[1]} expandable={slicedLogItems[1].length > 0}
                                expandLinkText={intl.formatMessage({id: "action.log.more"}, {count: slicedLogItems[1].length})} />
                {emptyMessage}
            </div>
        )
    }
}

EventLogTable.defaultProps = {
    initDisplayCount: 3,
}

export default injectIntl(EventLogTable)
